import { resetAllStores } from '~/utils/resetAllStores'

// Resetea los stores Pinia cuando el usuario autenticado CAMBIA sin pasar por
// el botón "Cerrar sesión": login de otra cuenta en otra pestaña, sesión
// expirada y re-login, etc. Sin esto, datos cacheados de una sesión (p. ej. la
// lista de procedimientos + el caché `lastFetch*`) se quedan visibles para el
// siguiente usuario hasta que caduque el caché o se recargue la página.
//
// NO resetea en TOKEN_REFRESHED / USER_UPDATED (mismo usuario) para no borrar
// el estado a media sesión.
export default defineNuxtPlugin(() => {
  const supabase = useSupabaseClient()
  let lastUserId: string | null | undefined = undefined

  supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'TOKEN_REFRESHED' || event === 'USER_UPDATED') return

    const newId = session?.user?.id ?? null

    // Primer evento (INITIAL_SESSION): solo fija el baseline, no resetea.
    if (lastUserId === undefined) {
      lastUserId = newId
      return
    }

    if (newId !== lastUserId) {
      const wasAuthenticated = lastUserId !== null
      resetAllStores()
      lastUserId = newId

      // @nuxtjs/supabase's auth-redirect only runs on route navigation, not mid-session.
      // When the JWT + refresh token expire while the user is on a page (no navigation),
      // Supabase JS fires SIGNED_OUT but nothing redirects. Handle it here.
      if (event === 'SIGNED_OUT' && wasAuthenticated) {
        navigateTo('/auth/login')
      }
    }
  })
})
